import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SingleCardComponent } from 'src/app/layouts';

/**
 * Wrapper para todas las rutas de autenticación. Mapea la ruta actual a las
 * claves de traducción del título/descripción que `single-card` resuelve via
 * `| translate` antes de pasarlos al `<app-card-auth>` interno.
 *
 * Las claves viven en `assets/i18n/{es,en,pt}.json` bajo `auth.titulos.*` y
 * `auth.subtitulos.*`. Si la ruta no tiene match, se devuelve string vacío
 * (el card-auth oculta el subtítulo cuando está vacío).
 */
@Component({
  selector: 'app-unauthenticated-content',
  template: `
    <app-single-card [titleKey]="titleKey" [descriptionKey]="descriptionKey">
      <router-outlet></router-outlet>
    </app-single-card>
  `,
  styles: [`
    :host {
      width: 100%;
      height: 100%;
    }
  `],
  imports: [
    CommonModule,
    RouterModule,
    SingleCardComponent,
  ],
})
export class UnauthenticatedContentComponent {
  private router = inject(Router);

  get titleKey(): string {
    const path = this.router.url.split('/').at(-1)?.split('?')[0] ?? '';
    switch (path) {
      case 'sign-in':         return 'auth.iniciarSesion';
      case 'reset-password':  return 'auth.titulos.resetPassword';
      case 'register':        return 'auth.titulos.register';
      case 'change-password': return 'auth.titulos.changePassword';
      default:                return '';
    }
  }

  get descriptionKey(): string {
    const path = this.router.url.split('/').at(-1)?.split('?')[0] ?? '';
    switch (path) {
      case 'sign-in':         return 'auth.subtitulos.signIn';
      case 'reset-password':  return 'auth.subtitulos.resetPassword';
      case 'register':        return 'auth.subtitulos.register';
      default:                return '';
    }
  }
}
